/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlComponents
 */
export interface ControlComponents {
}

/**
 * Check if a given object implements the ControlComponents interface.
 */
export function instanceOfControlComponents(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlComponentsFromJSON(json: any): ControlComponents {
    return ControlComponentsFromJSONTyped(json, false);
}

export function ControlComponentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlComponents {
    return json;
}

export function ControlComponentsToJSON(value?: ControlComponents | null): any {
    return value;
}

